function OffHoursScheduleDisplay(aSchedule) {
    "use strict";
    this.__type = 'OffHoursSchedule:www.veritracks.com';
    this.Id = aSchedule.Id;
    this.Version = aSchedule.Version;
    this.StartTimeUTC = aSchedule.StartTimeUTC;
    this.EndTimeUTC = aSchedule.EndTimeUTC;
    this.EndTime = aSchedule.EndTime;
    this.IsActive = aSchedule.IsActive;
    this.IsFriday = aSchedule.IsFriday;
    this.IsMonday = aSchedule.IsMonday;
    this.IsNoSchedule = aSchedule.IsNoSchedule;
    this.IsRecurring = aSchedule.IsRecurring;
    this.IsSaturday = aSchedule.IsSaturday;
    this.IsSunday = aSchedule.IsSunday;
    this.IsThursday = aSchedule.IsThursday;
    this.IsTuesday = aSchedule.IsTuesday;
    this.IsWednesday = aSchedule.IsWednesday;
    this.Name = aSchedule.Name;
    this.StartTime = aSchedule.StartTime;
    var lAgent = getDataItem(aSchedule.AgentId, 'Agents');
    if (FixGetTime(this.StartTime, lAgent.TimeZoneId) == 1) {
        this.IsSaturday = aSchedule.IsSunday;
        this.IsSunday = aSchedule.IsMonday;
        this.IsMonday = aSchedule.IsTuesday;
        this.IsTuesday = aSchedule.IsWednesday;
        this.IsWednesday = aSchedule.IsThursday;
        this.IsThursday = aSchedule.IsFriday;
        this.IsFriday = aSchedule.IsSaturday;
    }
    else if (FixGetTime(this.StartTime, lAgent.TimeZoneId) == 0) {
        this.IsSaturday = aSchedule.IsFriday;
        this.IsSunday = aSchedule.IsSaturday;
        this.IsMonday = aSchedule.IsSunday;
        this.IsTuesday = aSchedule.IsMonday;
        this.IsWednesday = aSchedule.IsTuesday;
        this.IsThursday += aSchedule.IsWednesday;
        this.IsFriday = aSchedule.IsThursday;
    }

    this.AgentId = aSchedule.AgentId;

}
if (typeof exports !== 'undefined') {
    module.exports = OffHoursScheduleDisplay;
}